import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PrismLabel from './../label/prismLabel';
import PrismErrorsContainer from '../utilities/prismErrorsContainer';
import Input from '@prism/input';
import { FormGroup } from '@prism/form';

class PrismInput extends React.PureComponent {
    onHandlePasteValue = (isPaste, event) => {
        if (!isPaste) {
            event.preventDefault();
        }
    };

    renderLabel = ({
        id,
        label,
        required
    }) => typeof label === 'string'
        ? (
            <PrismLabel for={id}>
                {label}
                {required && '*'}
            </PrismLabel>
        )
        : label;

    renderInput = ({ valid, invalid, disabled, className, isPaste, ...props }) => (
        <Input
            {...props}
            disabled={disabled}
            valid={valid && !disabled}
            invalid={invalid && !disabled}
            className={className}
            onPaste={(event) => this.onHandlePasteValue(isPaste, event)}
        />
    );

    renderHelp = ({ help }) => typeof help === 'string'
        ? (
            <span className='prism-input__help'>
                {help}
            </span>
        )
        : help;

    renderErrors = ({ errors, invalid }) => {
        const className = classNames({ 'prism-errors-container--visible': invalid });

        return <PrismErrorsContainer errors={errors} className={className} />;
    };

    render() {
        const {
            className,
            inputClassName,
            label,
            help,
            errors,
            ...inputProps
        } = this.props;

        const containerClassName = classNames(
            'prism-sandbox',
            'prism-input',
            className
        );
        const elementClassName = classNames(
            'prism-input__control',
            inputClassName
        );

        return (
            <div className={containerClassName}>
                <FormGroup>
                    {label && this.renderLabel(this.props)}
                    {this.renderInput({ ...inputProps, className: elementClassName })}
                    {help && this.renderHelp(this.props)}
                    {errors && this.renderErrors(this.props)}
                </FormGroup>
            </div>
        );
    }
}

PrismInput.propTypes = {
    innerRef: PropTypes.object,
    id: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    autofocus: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    valid: PropTypes.bool,
    invalid: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    isPaste: PropTypes.bool
};

PrismInput.defaultProps = {
    type: 'text',
    value: '',
    isPaste: true,
    errors: [],
    onBlur: () => { }
};

export default PrismInput;
